"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.POLICY_STATUS_LABEL_MAP = exports.POLICY_STATUS_BADGE_MAP = void 0;
var coverage_api_1 = require("@newfront-insurance/coverage-api");
exports.POLICY_STATUS_BADGE_MAP = (_a = {},
    _a[coverage_api_1.PolicyStatus.ACTIVE] = 'success',
    _a[coverage_api_1.PolicyStatus.EXPIRED] = 'secondary',
    _a[coverage_api_1.PolicyStatus.CANCELLED] = 'danger',
    _a[coverage_api_1.PolicyStatus.UPCOMING] = 'info',
    _a);
exports.POLICY_STATUS_LABEL_MAP = (_b = {},
    _b[coverage_api_1.PolicyStatus.ACTIVE] = 'Active',
    _b[coverage_api_1.PolicyStatus.EXPIRED] = 'Expired',
    _b[coverage_api_1.PolicyStatus.CANCELLED] = 'Cancelled',
    _b[coverage_api_1.PolicyStatus.UPCOMING] = 'Upcoming',
    _b);
